import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "flex-start",
        minWidth: 0
    }
});
export default stylesheet;
